import type {
	Components,
} from '@mui/material'

export const materialUIChipTheme: {
	components: Components
} = {
	components: {
		MuiChip: {
			defaultProps: {
				variant: 'filled',
				color:   'primary',
			},
			styleOverrides: {
				root: {
					fontWeight: 500,
				},
				sizeSmall: {
					fontSize: '0.6875rem',
					height:   '1.25rem',
					padding:   '0 0.25rem',
				},
				sizeMedium: {
					fontSize: '0.75rem',
					height:   '1.5rem',
				},
			},
			variants: [
				/* filled styles */
				{
					props: {
						variant: 'filled',
						color:   'primary',
					},
					style: {
						backgroundColor: 'var(--primary-color)',
						color:           'var(--on-primary-color)',
					},
				},
				{
					props: {
						variant: 'filled',
						color:   'secondary',
					},
					style: {
						backgroundColor: 'var(--secondary-color)',
						color:           'var(--on-secondary-color)',
					},
				},
				{
					props: {
						variant: 'filled',
						color:   'warning',
					},
					style: {
						backgroundColor: 'var(--warning-color)',
						color:           'var(--on-warning-color)',
					},
				},
				{
					props: {
						variant: 'filled',
						color:   'success',
					},
					style: {
						backgroundColor: 'var(--positive-color)',
						color:           'var(--on-positive-color)',
					},
				},

				/* outlined styles */
				{
					props: {
						variant: 'outlined',
						color:   'primary',
					},
					style: {
						borderColor: 'var(--primary-color)',
						color:       'var(--on-surface-color)',
					},
				},
				{
					props: {
						variant: 'outlined',
						color:   'secondary',
					},
					style: {
						borderColor: 'var(--secondary-color)',
						color:       'var(--on-surface-color)',
					},
				},
				{
					props: {
						variant: 'outlined',
						color:   'warning',
					},
					style: {
						borderColor: 'var(--warning-color)',
						color:       'var(--warning-color)',
					},
				},
				{
					props: {
						variant: 'outlined',
						color:   'success',
					},
					style: {
						borderColor: 'var(--positive-color)',
						color:           'var(--positive-color)',
					},
				},
			],
		},
	},
}
